module.exports = __webpack_public_path__ + "static/media/shopping_anchorage_marker.224e1c5f.svg";